import React from "react";

import { Grid } from "@material-ui/core";
import { ContainerCardMaterial } from "components/haven-design";

const ContainerWithSidebar: React.FC<{children: React.ReactNodeArray}> = ({ children }) => (
  <ContainerCardMaterial>
    <Grid item sm={3} xs={12}>
      {children ? children[0] : ""}
    </Grid>
    <Grid item sm={9} xs={12}>
      {children ? children[1] : ""}
    </Grid>
  </ContainerCardMaterial>
);

export default ContainerWithSidebar;
